import { render, staticRenderFns } from "./BulkAssignApw.vue?vue&type=template&id=86ed0618&"
import script from "./BulkAssignApw.vue?vue&type=script&lang=js&"
export * from "./BulkAssignApw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports